import React from 'react'
import api from '../../../service/api';
import './index.scss';
import play from '../../../assets/image/play@3x.png';
import LazyLoadImg from '../../aelComponent/LazyLoadImg';
import utils from 'bxl-utils';

const RecommendArticlesWide = (props) => {
  const { data, index } = props;
  if (!data) return ''
  return (
    <a href={data.legoId ? `/art/${data.legoId}/` : `/article/${data.id}/`}>
      <div className='recommendArticlesFirst'
        id={data.id}
        data-index={index}
        data-pid='recommendArticles'
      >
        <div className='r_a_f_top'>
          <LazyLoadImg image={api.getResource(data.image)} alt={`${data.title || ''} ${data.authorLabel} article img`} className='r_a_f_img'></LazyLoadImg>
          {
            data.video && <img className='r_a_f_play' src={play} alt="play icon" />
          }
        </div>
        <div className='r_a_f_main'>
          <img className='r_a_f_main_left' src={api.getResource(data.authorAvatar)} alt="avatar icon" />
          <div className='r_a_f_main_right'>
            <h3 className='r_a_f_m_tit'>{data.title}</h3>
            <div className='r_a_f_m_auther'>{data.authorLabel} {data.date}</div>
          </div>
        </div>
        <div className="line"></div>
      </div>
    </a>
  )
}

export default RecommendArticlesWide
